import React, {useEffect, useState} from 'react'
import {Pagination, message} from "antd"
import CustomersTable from "./datas/CustomersTable"
import CustomerFilters from "./filters/CustomerFilters"
import UseDebounce from "../../shared/UseDebounce"
import CustomersHubProvider from "./CustomersHubProvider"
import CustomerForm from "./shared/CustomerForm"
import FilterInput from "../../customers/components/filters/FilterInput"
import parseToken from "../../../helpers/parseToken"
import {searchTenantHub} from "../../../services/api/apiCustomerHub"
import {searchTenant} from "../../../services/api/apiUser"
import _checkRoles from "../../../helpers/checkRole"

function CustomersHubPage() {
    const decodeToken = parseToken()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [listCustomers, setListCustomers] = useState([])

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [nameCode, setNameCode] = useState('')
    const [salePersonName, setSalePersonName] = useState('')
    const [parentId, setParentId] = useState('')
    const [tenants, setTenants] = useState([])

    const [limit, setLimit] = useState(20)
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)

    const [showFilter, setShowFilter] = useState(false)

    const _onToggleFilter = () => {
        setShowFilter(!showFilter)
    }

    const _onClearFilters = () => {
        setName('')
        setEmail('')
        setPhone('')
        setNameCode('')
        setSalePersonName('')
        setParentId('')
        setPage(1)
    }

    const _fetchListTenant = async () => {
        try {
            const payload = {page: 1, limit: 10000}
            const response = await searchTenant(payload, decodeToken.sub)
            const {success, data, message: error} = response

            if (success !== '1') {
                return message.error(error)
            }

            const _tenants = data.map(item => ({
                label: item.name,
                value: item.id,
            }))
            setTenants(_tenants)
        } catch (e) {
            message.error(e.message)
        }
    }

    const _onChangeParentId = (value) => {
        setParentId(value || '')
        setPage(1)
    }

    const _handleChangeInput = (e) => {
        const {name, value} = e.target

        if (name === 'name') {
            setName(value)
        } else if (name === 'nameCode') {
            setNameCode(value)
        } else if (name === 'email') {
            setEmail(value)
        } else if (name === 'salePersonName') {
            setSalePersonName(value)
        } else {
            setPhone(value)
        }
        setPage(1)
    }

    const _onChangeLimit = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const _fetchListCustomer = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                email,
                name,
                nameCode,
                salePersonName,
                parentId,
                limit,
                page,
                phoneNumber: phone
            }

            const response = await searchTenantHub(decodeToken.sub, payload)
            const {success, data, error_message, totalRecord} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return setError(error_message)
            }

            setLoading(false)
            setListCustomers(data)
            setTotal(totalRecord)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const debouncedSearchName = UseDebounce(name, 1000)
    const debouncedSearchEmail = UseDebounce(email, 1000)
    const debouncedSearchPhone = UseDebounce(phone, 1000)
    const debouncedSearchNameCcode = UseDebounce(nameCode, 1000)
    const debouncedSearchSalePersonName = UseDebounce(salePersonName, 1000)

    useEffect(() => {
        _fetchListTenant()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        _fetchListCustomer()
        // eslint-disable-next-line
    }, [debouncedSearchName, debouncedSearchEmail, debouncedSearchPhone, debouncedSearchNameCcode, debouncedSearchSalePersonName, parentId, limit, page])

    // Phase 4: format range text
    const fromRecord = total > 0 ? (page - 1) * limit + 1 : 0
    const toRecord = Math.min(page * limit, total)

    return (
        <CustomersHubProvider getCustomers={_fetchListCustomer}>
            <div className="CustomersPage PageDefault">
                <div className="PageHeading">
                    <h1 className="PageTitle"></h1>
                    <div className="PageFilterTop">
                        <FilterInput
                            label=""
                            name="name"
                            placeholder="Tìm kiếm khách hàng"
                            value={name}
                            onChangeInput={_handleChangeInput}
                        />
                        <div className="FiltersOpen" onClick={_onToggleFilter}>
                            <span className="material-icons Filter">filter_list</span>
                            <label>Bộ lọc</label>
                        </div>
                        {_checkRoles('menu.customerhub.addNew') &&
                            <CustomerForm item={{}} label="Thêm khách hàng" type="add"/>}
                    </div>
                </div>

                {showFilter && (
                    <CustomerFilters
                        name={name}
                        phone={phone}
                        email={email}
                        nameCode={nameCode}
                        salePersonName={salePersonName}
                        parentId={parentId}
                        tenants={tenants}
                        onChangeInput={_handleChangeInput}
                        onChangeParentId={_onChangeParentId}
                    />
                )}

                {/* Phase 3: Table */}
                <div className="ContentPage">
                    <CustomersTable
                        loading={loading}
                        page={page}
                        limit={limit}
                        error={error}
                        listCustomers={listCustomers}
                    />

                    {/* Phase 4: Enhanced pagination */}
                    <div className="FooterTable">
                        <div className="Total">
                            {total > 0
                                ? `Hiển thị ${fromRecord}-${toRecord} / ${total.toLocaleString('vi-VN')} khách hàng`
                                : 'Không có dữ liệu'
                            }
                        </div>
                        <Pagination
                            className="PaginationCustom"
                            showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            total={total}
                            current={page}
                            pageSize={limit}
                            onChange={_onChangeLimit}
                        />
                    </div>
                </div>
            </div>
        </CustomersHubProvider>
    )
}

export default CustomersHubPage
